module.exports = __webpack_public_path__ + "assets/i18n/en.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = 1204
// module chunks = 0